module.exports = __webpack_public_path__ + "static/img/award-2.990b07b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/award-2.jpg
// module id = loq3
// module chunks = 1